import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    meta:{
      title:process.env.VUE_APP_NAME + "首页" ,
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/index.vue"),
  },
  {
    path: "/login",
    name: "Login",
    meta:{
      title:process.env.VUE_APP_NAME + "登录" ,
      hideMenu:true
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/login/Login.vue"),
  },
  {
    path: "/review",
    name: "Review",
    meta:{
      title:process.env.VUE_APP_NAME + "评审列表" ,
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/review.vue"),
  },
  {
    path: "/review_work",
    name: "ReviewWork",
    meta:{
      title:process.env.VUE_APP_NAME + "评审列表" ,
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/review_work.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  //404重定向登录页面
  if (to.matched.length === 0) {
      window.location.href = "/review/";
  }
  if (to.meta.title) {
      /*路由发生改变修改页面的title */
      document.title = to.meta.title;
  }
  next();
});

export default router;
